import { required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ErrorList from "./ErrorList"
import {stepsConstants} from "../../data/steps";

export default {
  props: ['formData', 'formOptions', 'formLabels'],
  components: {
    ErrorList
  },
  methods: {
    setErrorId(fieldName) {
      const errors = this.v$.formData[fieldName].$errors
      return errors.length ? `errors--${fieldName}` : null
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      formData: {
        occupation: {
          required: helpers.withMessage(stepsConstants.please_fill_radio_group, required),
        }
      }
    }
  },
  template: `
    <div class="application__fields__input-group">
        <div class="form__title"></div>

        <div v-for="text in formOptions.occupation" class="form__radio-outer">
            <label class="form__label">
                <input :aria-describedby="setErrorId('occupation')" type="radio" v-model="formData.occupation" name="occupation" :value="text" required>
                {{text}}
            </label>
        </div>
        <error-list :errors="v$.formData.occupation.$errors" :id="setErrorId('occupation')"/>
    </div>
    `
}
